module.exports = __webpack_public_path__ + "img/BIT_white28.17a5308b.jpg";